import React, { Component } from 'react';
import _ from 'lodash';
import NgssTagGroup from '../../components/NgssTagGroup';
import BulkAssignmentUpsertionForm from './BulkAssignmentUpsertionForm';
import BulkAssignmentDeletionForm from './BulkAssignmentDeletionForm';
import '../../assets/css/components/popups.css';
import '../../assets/css/components/assignment-popup.css';
import { getSandboxName } from '../../util';

const AssignmentPopup = props => {

  const { resolveDecision, getConflictMessage, conflicts, resetNotifications, expandableDetails, showExpandableDetails, upsertedAssignmentObject } = props //notification-related props

  const { selectedDateArray, selectedDateIndex, setSelectedDate, checkTextDate, setSelectedIndex } = props // date related props

  const { assignableContent, usingDeletionForm, deletedAssignments, resultsCollection, onSubmitNew, onSubmitDelete, resetForm, studentGroupings, handleClose, isFetching, isUpserting, isDeleting,  upsertError, deleteErrors, fetchedRequestId, submitWasSuccessful, defaultAssignees, onSubmitUpsertion, getSuccessMessage, getDeletionSuccessMessage,formattedUpsertionGroupInfo, formChanged, onAssigneeChange } = props //other props

  const ngssContentCount = ()=> {
    if(!assignableContent){ return 0 }
    return _.isEmpty(assignableContent) ? 0 : _.compact(_.flatten([assignableContent.ngssSeps, assignableContent.ngssDcis, assignableContent.ngssCccs, assignableContent.ngssPes])).length;
  }
  const getContentType = ()=>{
    if(assignableContent.type === 'quests'){
        switch(assignableContent.questType){
          case 'Sequence Quest':
            return 'storyline'
          case 'Enrichment Quest':
            return 'enrichment'
          case 'Practice Quest':
            return 'practice'
        }
      }
    else if (assignableContent.type === 'sequences'){ return 'sequence' }
    else if (assignableContent.type === 'modules'){ return 'sandbox-unlock' }
  }

  const getContentTypeTitle = ()=>{
    var contentType
    switch(getContentType()){
      case 'enrichment':
        contentType = 'Enrichment Quest'
        break;
      case 'practice':
        contentType = 'Practice Quest'
        break;
      case 'storyline':
        contentType = 'Storyline Quest'
        break;
      case 'sandbox-unlock':
        contentType = 'Sandbox-Unlock Quest'
        break;
      default:
        contentType = 'Storyline'
        break;
    }
    return contentType
  }
  return(
    <div data-testid="assignmentPopup" className='assignment-popup popup-content popup dialog responsive-popup dialog--open'>
      <div onClick={()=>{handleClose(); resetForm()}} className='popup-background'></div>
      {assignableContent &&
        <div className="dialog__content">
          <div className="container-fluid">
            <div className="dialog__overview">
              <div id="standard-col" className="col-md-4 p-r-20 p-t-30 p-l-20 item-description">
              <span className="content-title">
                <div className={"content-color " + getContentType()}></div>
                <div className="font-montserrat fs-11 card-type">{getContentTypeTitle()}</div>
              </span>
                <h2 className="semi-bold no-margin font-montserrat" id="assignableContent-name">
                  {assignableContent.name || assignableContent.title}
                </h2>
                <br/>
                {(assignableContent.educationalDescription || assignableContent.description) &&
                  <div>
                    <p className="fs-13 " id="assignableContent-educational-description">
                      {assignableContent.educationalDescription || assignableContent.description}
                    </p>
                    <br/>
                  </div>
                }
                {ngssContentCount() === 0 &&
                  <p className="fs-13 text-white"><b>There's no NGSS content associated with this {getContentType().toLowerCase()}.</b></p>
                }
                {ngssContentCount() !== 0 &&
                  <NgssTagGroup objectWithNgssTags={assignableContent} size='small'/>
                }
                <br/><br/>
              </div>
              <div id="assignableContent-col" className="col-md-8 p-r-20 p-t-30 p-l-20 item-description bg-grey">

                <div className="tab-content">
                  <div className="tab-pane active" id="tab-fillup1">
                    <br/>
                    <div id='assignment-form-wrapper'>
                      {usingDeletionForm &&
                        <BulkAssignmentDeletionForm
                          deletableContent={assignableContent}
                          deletedAssignments={deletedAssignments}
                          studentGroupings={studentGroupings}
                          onSubmit={onSubmitDelete}
                          isFetching={isFetching}
                          isDeleting={isDeleting}
                          deleteErrors={deleteErrors}
                          fetchedRequestID={fetchedRequestId}
                          onAssigneeChange={onAssigneeChange}
                          defaultAssignees={defaultAssignees}
                          getSuccessMessage={getDeletionSuccessMessage}
                        />
                      }
                      {!usingDeletionForm &&
                        <BulkAssignmentUpsertionForm
                          assignableContent={assignableContent}
                          studentGroupings={studentGroupings}
                          onSubmitNew={onSubmitNew}
                          isUpserting={isUpserting}
                          isFetching={isFetching}
                          fetchedRequestId={fetchedRequestId}
                          submitWasSuccessful={submitWasSuccessful}
                          resultsCollection={resultsCollection}
                          upsertError={upsertError}
                          upsertedAssignmentObject={upsertedAssignmentObject}
                          selectedDateArray={selectedDateArray}
                          selectedIndex={selectedDateIndex}
                          setSelectedDate={setSelectedDate}
                          checkTextDate={checkTextDate}
                          setSelectedIndex={setSelectedIndex}
                          onSubmit={onSubmitUpsertion}
                          defaultAssignees={defaultAssignees}
                          resolveDecision={resolveDecision}
                          getConflictMessage={getConflictMessage}
                          conflicts={conflicts}
                          resetNotifications={resetNotifications}
                          expandableDetails={expandableDetails}
                          showExpandableDetails={showExpandableDetails}
                          getSuccessMessage={getSuccessMessage}
                          formattedUpsertionGroupInfo={formattedUpsertionGroupInfo}
                          formChanged={formChanged}
                          onAssigneeChange={onAssigneeChange}
                        />
                      }
                    </div>
                    <br/>
                  </div>

                  <div className="tab-pane" id="tab-fillup2">
                    <h2 className="semi-bold no-margin font-montserrat" id="standard-title">Edit Assignments</h2>
                    <div id='edit-assignment-form-wrapper'></div>
                    <br/><br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button onClick={()=>{handleClose(); resetForm()}} className="popup-close close action top-right" data-dialog-close=""><i className="fa fa-times"></i></button>
        </div>
      }
    </div>
  );
}

export default AssignmentPopup;
